import { createSlice } from '@reduxjs/toolkit';
import { stripMongoProperties } from 'client/api-utils';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { IQuery, IQueryResult } from 'common/interfaces/query';

const initialState = {
  result: null as null | IQueryResult,
  queries: [] as IQuery[],
  isRunning: false,
};

const query = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    queryRunStarted: (state) => {
      state.result = null;
      state.isRunning = true;
    },
    queryRunSucceeded: (state, action) => {
      state.result = action.payload;
      state.isRunning = false;
    },
    queryRunFailed: (state) => {
      state.isRunning = false;
    },
    upsertSucceeded: (state, action) => {
      const newQuery = action.payload as IQuery;
      const index = state.queries.findIndex(oldQuery => oldQuery.queryid === newQuery.queryid);
      if (index >= 0) {
        const { queries } = state;
        queries[index] = newQuery;
        state.queries = queries;
      } else {
        state.queries = [...state.queries, action.payload];
      }
    },
    queryDraftAdded: (state, action) => {
      state.queries = [...state.queries, action.payload];
    },
    queriesRecieved: (state, action) => {
      state.queries = action.payload;
    },
    queryDeleted: (state, action) => {
      const { queries } = state;
      const index = queries.findIndex(query => query.queryid === action.payload.queryid);
      queries.splice(index, 1);
      state.queries = queries;
    },
    queryResultReset: (state) => {
      state.result = null;
    },
  },
});

export const {
  queryRunStarted,
  queryRunSucceeded,
  queryRunFailed,
  upsertSucceeded,
  queryDraftAdded,
  queriesRecieved,
  queryDeleted,
  queryResultReset,
} = query.actions;

export default query.reducer;

export const runQuery = (query: IQuery) => apiCallBegan({
  url: `query?archiveid=${query.archiveid}`,
  method: 'POST',
  onStart: queryRunStarted.type,
  data: stripMongoProperties(query),
  // @ts-ignore
  onSuccess: (response) => ({
    type: queryRunSucceeded.type,
    payload: response,
  }),
  onError: queryRunFailed.type,
});

// @ts-ignore
export const upsertQuery = (query: IQuery) => apiCallBegan({
  url: '/custom-query',
  method: 'POST',
  data: stripMongoProperties<IQuery>(query),
  // @ts-ignore
  onSuccess: (response) => ({
    type: upsertSucceeded.type,
    payload: { ...query, ...response },
  }),
});

// @ts-ignore
export const getQueries = () => apiCallBegan({
  url: '/custom-query',
  method: 'GET',
  // @ts-ignore
  onSuccess: (response) => ({
    type: queriesRecieved.type,
    payload: response,
  }),
});

// @ts-ignore
export const deleteQuery = (queryId: string) => apiCallBegan({
  url: `/custom-query/${queryId}`,
  method: 'DELETE',
  // @ts-ignore
  onSuccess: (response) => ({
    type: queryDeleted.type,
    payload: response,
  }),
});